<template>
  <v-container fluid class="mr-10">
    <div v-if="hasAuthorities()" class="mx-10">
      <TitleRow title="SDI - Movimentação" />
      <MovementSection @verifyAuthorityMovements="handleVerifyAuthorityMovements" />

      <SeparatorGradient v-if="authorityMovements" />

      <FileConfigurationSection @verifyAuthorityFileConfigurations="handleVerifyAuthorityFileConfigurations" />

      <SeparatorGradient v-if="authorityFileConfigurations" />

      <ServiceConfigurationSection @verifyAuthorityServiceConfigurations="handleVerifyAuthorityServiceConfigurations" />

      <SeparatorGradient v-if="authorityServiceConfigurations" />

      <GeneralParameterSection @verifyAuthorityGeneralParameters="handleVerifyAuthorityGeneralParameters" />
    </div>

    <v-row v-else align="center" justify="center" class="mt-15">
      <v-col align="center" cols="12">
      <v-row justify="center" class="mt-3">
        <v-col cols="12" md="3" lg="3" align="center">
          <v-icon large color="primary">fas fa-low-vision</v-icon>
        </v-col>
      </v-row>

      <v-row justify="center" class="mt-3">
        <v-col cols="12" md="3" lg="3" align="center">
        <p class="foreground--text label">Você não tem permissão para visualizar os menus.</p>
        </v-col>
      </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import MovementSection from '@/components/Home/AllMenus/MovementSection.vue';
import FileConfigurationSection from '@/components/Home/AllMenus/FileConfigurationSection.vue';
import GeneralParameterSection from '@/components/Home/AllMenus/GeneralParameterSection.vue';
import SeparatorGradient from '@/components/Home/AllMenus/SeparatorGradient.vue';
import ServiceConfigurationSection from '@/components/Home/AllMenus/ServiceConfigurationSection.vue';
import TitleRow from '@/components/Home/AllMenus/TitleRow.vue';
import { mapMutations } from 'vuex';

export default ({
  components: {
    MovementSection,
    FileConfigurationSection,
    GeneralParameterSection,
    SeparatorGradient,
    TitleRow,
    ServiceConfigurationSection,
  },
  data: () => ({
    isRHProtegido: false,
    authorityMovements: true,
    authorityFileConfigurations: true,
    authorityServiceConfigurations: true,
    authorityGeneralParameters: true,
  }),

  async mounted() {
    this.clearSessionStorage();
    if (this.isRHProtegido) this.redirectRouter('HomeRHProtegido', { isRHProtegido: this.isRHProtegido });
  },

  mixins: [
    VerifyRoutesMixin,
  ],

  methods: {
    ...mapMutations({
      setAppOrigin: 'user-info/setAppOrigin'
    }),
    clearSessionStorage() {
      const keyTheme = 'theme';
      const valueTheme = sessionStorage.getItem(keyTheme);
      const keyToken = '@auth/token';
      const valueToken = sessionStorage.getItem(keyToken);
      const keyUser = '@auth/user';
      const keyAppOrigin = '@sdi/app_origin';
      const valueUser = sessionStorage.getItem(keyUser);

      sessionStorage.clear();
      sessionStorage.setItem(keyTheme, valueTheme);
      sessionStorage.setItem(keyToken, valueToken);
      sessionStorage.setItem(keyUser, valueUser);
      sessionStorage.removeItem('financialGroupId');
      if(this.isRHProtegido){
        this.setAppOrigin('PROTECTED_HR')
        // sessionStorage.setItem(keyAppOrigin, 'PROTECTED_HR');
      }else {
        this.setAppOrigin('BACKOFFICE')
        // sessionStorage.setItem(keyAppOrigin, 'BACKOFFICE');
      }
    },
    handleVerifyAuthorityMovements(hasAuthorityToAccess) {
      this.authorityMovements = hasAuthorityToAccess;
    },
    handleVerifyAuthorityFileConfigurations(hasAuthorityToAccess) {
      this.authorityFileConfigurations = hasAuthorityToAccess;
    },
    handleVerifyAuthorityServiceConfigurations(hasAuthorityToAccess) {
      this.authorityServiceConfigurations = hasAuthorityToAccess;
    },
    handleVerifyAuthorityGeneralParameters(hasAuthorityToAccess) {
      this.authorityGeneralParameters = hasAuthorityToAccess;
    },
    hasAuthorities() {
      if (this.authorityMovements || this.authorityFileConfigurations || this.authorityGeneralParameters) {
        return true;
      }
      return false;
    },
  },
});
</script>
